// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__152KW","header":"PatientBlock_header__vvRti","label":"PatientBlock_label__2kUfa","option":"PatientBlock_option__2P6l3"};